import React from "react";
import {withRouter} from 'react-router';

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal,
    Row,
    Table,
} from "reactstrap";
import {Redirect} from "react-router-dom";
import ClassHeader from "../../components/Headers/ClassHeader";
import ClassApiService from "../../api/classes-api-service";

import {MdDelete} from 'react-icons/md';

import ClientInClassTableRow from "../../components/Tables/ClientInClassTableRow";
import ClientSearchTableRow from "../../components/Tables/ClientSearchTableRow";
import StudentApiService from "../../api/student-api-service";
import CardHeader from "reactstrap/es/CardHeader";

import LocalizedStrings from "react-localization";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";

import 'react-confirm-alert/src/react-confirm-alert.css';
import {alert_strings} from "../../translations/alert_translations";
import ResourceItem from "../../components/Lists/ResourceItem";
import TicketTypeApiService from "../../api/tt-api-service";
import EditTicketView from "../../components/Resources/Ticket/EditTicketView";
import ticketHelpers from "../../helpers/TiketHelper";
import TicketApiService from "../../api/ticket-api-service";
import StudentPreview from "../../components/client/StudentPreview";
import businessHelper from "../../helpers/BusinessHelper";
import EditClassView from "../../components/Resources/Yclass/EditClassView";
import ResourceApiService from "../../api/resource-api-service";
import EditClassTypeView from "../../components/Resources/EditClassTypeView";
import ErrorModal from "../../components/Alerts/ErrorModal";
import lsHelpers from "../../helpers/LsHelper";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import NotProModal from "../../components/Alerts/NotProModal";
import ScannerAlert from "../../components/Alerts/ScannerAlert";
import ClassPlanView from "../../components/ClassViews/ClassPlanView";
import resourceHelper from "../../helpers/ResourceHelper";
import dateHelpers from "../../helpers/DateHelper";
import FeedbackComponent from "../../components/FeedbackComponent";
import constants from "../../shared/constants";
import {FadingBalls} from "react-cssfx-loading";

let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let alertStrings = new LocalizedStrings(alert_strings);

let filterTimeout;

class ClassOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            business: businessHelper.business(),
            isLoading: false,
            yclassId: props.location.state ? props.location.state.yclassId || -1 : -1,
            scheduleShift: props.location.state ? props.location.state.scheduleShift || -1 : -1,
            yclass: null,
            backToClassReport: props.location.state && props.location.state.backToClassReport,
            backToUnpaidReport: props.location.state && props.location.state.backToUnpaidReport,
            teachers: null,
            rooms: null,
            ticketTypes: null,
            inputStarted: false,
            lastAddedClientId: null,
            searchResults: [],
            showTicketTypeSelector: false,
            showClientPreviewFor: null,
            showClientPreview: false,
            showReminderAlert: false,
            reminderAlertFor: null,
            bookingCancelAlertFor: null,
            unregisterAlertFor: null,
            showReminderControls: false,
            reminderToShow: null,
            scrollToTop: false,
            moveToClientProfile: false,
            goToClientProfileId: false,
            showMessageModal: false,
            showExportModal: false,
            showClassEditor: false,
            showNotProModal: false,
            showClassTypeEditor: false,
            classPlanViewUpdated: 0,
            showFeedback: false,
            classType: null,
            message: {
                title: "",
                message: ""
            },
            alertData: null,
            scannerState: {
                state: 'pending',
                text: '',
                stateText: commonStrings.scan_state_scanning
            },
            error: null,
            showError: false,
            backToSchedule: false,
            classPlan: null,
            classPlans: [],
            classIsLoading: false
        };
    }

    handleSearchChange = this.handleSearchChange.bind(this);
    addToClass = this.addToClass.bind(this);
    showTicketTypes = this.showTicketTypes.bind(this);
    findCancellation_data = this.findCancellation_data.bind(this);
    closeTicketView = this.closeTicketView.bind(this);
    updateTicket = this.updateTicket.bind(this);
    createPaymentReminder = this.createPaymentReminder.bind(this);
    removeFromClass = this.removeFromClass.bind(this);
    markAsCancellation = this.markAsCancellation.bind(this);
    removeFromClass = this.removeFromClass.bind(this);
    unregisterFromClass = this.unregisterFromClass.bind(this);
    clientPreview = this.clientPreview.bind(this);
    closeClientPreview = this.closeClientPreview.bind(this);
    showReminderAlertView = this.showReminderAlertView.bind(this);
    goToClassFromReminder = this.goToClassFromReminder.bind(this);
    deleteReminder = this.deleteReminder.bind(this);
    goToPreviousClass = this.goToPreviousClass.bind(this);
    goToClientProfile = this.goToClientProfile.bind(this);
    handleMessageInputChange = this.handleMessageInputChange.bind(this);
    sendMessageAction = this.sendMessageAction.bind(this);
    showMessage = this.showMessage.bind(this);
    exportDataAction = this.exportDataAction.bind(this);
    showExportData = this.showExportData.bind(this);
    closeEditClassView = this.closeEditClassView.bind(this);
    showClassDeletionModal = this.showClassDeletionModal.bind(this);
    deleteClass = this.deleteClass.bind(this);
    closeEditClassTypeView = this.closeEditClassTypeView.bind(this);
    getTeachersAndRooms = this.getTeachersAndRooms.bind(this);
    editClassAction = this.editClassAction.bind(this);
    toggleScan = this.toggleScan.bind(this);
    showClassTypeEditor = this.showClassTypeEditor.bind(this);
    getClassType = this.getClassType.bind(this);
    confirmBooking = this.confirmBooking.bind(this);
    unconfirmBooking = this.unconfirmBooking.bind(this);
    showClassPlan = this.showClassPlan.bind(this);
    toggleFeedback = this.toggleFeedback.bind(this);
    recheckTickets = this.recheckTickets.bind(this);
    goToClassReport = this.goToClassReport.bind(this);
    goToUnpaidReport = this.goToUnpaidReport.bind(this);

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.yclassId !== this.state.yclassId) {
            this.getClass()
        }

        // if (this.state.scrollToTop === true) {
        //     window.scrollTo(0, 0);
        //     this.setState({scrollToTop: false})
        // }

        window.onpopstate = (e) => {
        }
    }

    addToClass(ev = null, id, confirmBooking = false) {
        if (ev) ev.preventDefault();
        this.closeSearch();

        this.setState({
            isLoading: true,
        });

        ClassApiService.registerClient(this.state.yclass.id, id)
            .then(res => {
                if (confirmBooking) this.confirmBooking(id)

                this.setState({
                    yclass: res,
                    isLoading: false,
                    lastAddedClientId: id,
                });

                this.showNoTicketWarningIfNeeded(id)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    componentWillMount() {
        this.getClass()
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.state.dayShift !== nextState.dayShift) {
            this.getTodayEvents(nextState.dayShift)
        }

        if (nextState.scrollToTop === true) {
            window.scrollTo(0, 0);
            this.setState({scrollToTop: false})
        }
    }

    anotherDayEvents(e, val) {
        this.setState(prevState => {
            return {dayShift: prevState.dayShift + val}
        });

        e.preventDefault()
    }

    resetShift(e) {
        this.setState(prevState => {
            return {dayShift: 0}
        });

        e.preventDefault()
    }

    refreshDayView = () =>
        this.setState({refreshDayView: !this.state.refreshDayView});

    getTodayEvents(shift = 0) {
        this.setState({isLoading: true});
    }

    renderTableData() {
        if (this.state.yclass) {
            return (this.updateFirstPosition(this.state.yclass.students)
                .concat(this.state.yclass.bookings)
                .concat(this.state.yclass.waitings)
                .concat(this.removeDuplicates(this.state.yclass.cancelled_students)))
                .map((student, index) => {
                    return (
                        <ClientInClassTableRow client={student} key={student.id} goToClient={this.goToClient}
                                               deleteClient={this.confirmDeletion}
                                               classTickets={this.state.yclass.tickets}
                                               isBooking={this.isBooking(student.id)}
                                               isWaiting={this.isWaiting(student.id)}
                                               isCancelled={this.isCancelled(student.id)}
                                               commonStrings={this.commonStrings}
                                               showTicketTypes={this.showTicketTypes}
                                               showClientPreview={this.clientPreview}
                                               confirmBooking={this.confirmBooking}
                                               unconfirmBooking={this.unconfirmBooking}
                                               confirmedBooking={this.isConfirmedBooking(student)}
                                               freeClass={this.state.yclass && this.state.yclass.is_free}
                                               cancellation_data={this.findCancellation_data(student, this.state.yclass)}
                        />
                    )
                })
        }
    }

    isBooking(clientId) {
        if (this.state.yclass && this.state.yclass.bookings && this.state.yclass.bookings.length > 0) {
            return this.state.yclass.bookings.find(b => b.id === clientId) !== undefined
        } else {
            return false
        }
    }

    isWaiting(clientId) {
        if (this.state.yclass && this.state.yclass.waitings && this.state.yclass.waitings.length > 0) {
            return this.state.yclass.waitings.find(b => b.id === clientId) !== undefined
        } else {
            return false
        }
    }

    isCancelled(clientId) {
        if (this.state.yclass && this.state.yclass.cancelled_students && this.state.yclass.cancelled_students.length > 0) {
            const res = this.state.yclass.cancelled_students.find(b => b.id === clientId) !== undefined;
            return res
        } else {
            return false
        }
    }

    renderSearchResults() {
        if (this.state.searchResults && this.state.searchResults.length > 0) {
            return this.state.searchResults.map((student, index) => {
                return (
                    <ClientSearchTableRow client={student} key={student.id} addToClass={this.addToClass}/>
                )
            })
        }
    }

    componentDidMount() {
        //this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
        // if (this.props.history.action === "POP") {
        //     // custom back button implementation
        // }

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
            this.recheckTickets()
        }
    }

    goToClassReport(e) {
        this.setState({goToClassReport: true})
    }

    goToUnpaidReport(e) {
        this.setState({goToUnpaidReport: true})
    }

    recheckTickets(e) {
        if (e) e.preventDefault();
        this.setState({isLoading: true});

        ClassApiService.recheckTickets(this.state.yclassId)
            .then(res => {
                this.getClass()
            })
            .catch((e) => {
                console.log(e.message)
            })
            .finally(() => {
                this.setState({isLoading: false});
            });
    }

    routerWillLeave(nextState) { // return false to block navigation, true to allow
        if (nextState.action === 'POP') {
            // handle "Back" button clicks here
        }
    }

    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index
        });

        this.getAttendanceStats(index === 1 ? "month" : "week")
    };

    render() {
        this.localize();

        if (this.state.moveToClientProfile === true && this.state.goToClientProfileId) {
            //return <Redirect from="*" to={`/admin/student-profile?id=${this.state.goToClientId}`}/>
            return <Redirect from="*" to={{
                pathname: "/admin/student-profile",
                state: {
                    clientId: this.state.goToClientProfileId,
                    backToClass: this.state.yclass
                }
            }}/>

        }

        if (this.state.goToClassReport) {
            return <Redirect from="*" to={{
                pathname: "/admin/tables",
                state: {reportName: constants.reports.attendanceReport}
            }}/>

        }

        if (this.state.goToUnpaidReport) {
            return <Redirect from="*" to={{
                pathname: "/admin/tables",
                state: {reportName: constants.reports.studentWithUnpaidClassesReport}
            }}/>

        }

        if (this.state.backToSchedule === true) {
            return <Redirect from="*" to={{
                pathname: "/admin/schedule",
            }}/>

        }

        if (this.state.showTicketEditor === true || this.state.showTicketTypeSelector === true || this.state.showClientPreview === true) {
            window.scrollTo(0, this.secondarySectionRef.offsetTop);
        }

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <>

                {this.state.showReminderControls && this.state.reminderToShow !== null &&
                this.renderReminderControls()
                }

                {this.state.showFeedback &&
                this.renderFeedbackModal()
                }

                {this.state.showMessageModal === true &&
                this.renderSendMessageModal()
                }

                {this.state.showExportModal === true &&
                this.renderExportDataModal()
                }

                {this.state.showClassDeletionModal === true &&
                this.renderDeletionModal()
                }

                {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                     toggleErrorModal={() => this.toggleErrorModal()}/>}

                {this.state.showNotProModal === true && <NotProModal showNotProModal={this.state.showNotProModal}
                                                                     toggleNotProModal={() => this.toggleNotProModal()}/>}

                {this.state.reminderAlertFor !== null &&
                <Modal
                    className="modal-dialog-centered modal-danger"
                    contentClassName="bg-gradient-warning"
                    isOpen={this.state.showReminderAlert}
                    toggle={() => this.toggleShowReminderAlert("notificationModal")}
                >
                    <div className="modal-header">
                        <h6 className="modal-title" id="modal-title-notification">
                            {/*Your attention is required*/}
                        </h6>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleShowReminderAlert("notificationModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="py-3 text-center">
                            <i className="ni ni-bell-55 ni-3x"/>
                            <h4 className="heading mt-4">{alertStrings.create_reminder}?</h4>
                            <p>
                                {alertStrings.formatString(alertStrings.no_ticket_reminder, this.state.reminderAlertFor.name, this.state.reminderAlertFor.name)}
                            </p>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button className="btn-white" color="default" type="button"
                                onClick={this.createPaymentReminder}>
                            {alertStrings.create_reminder}
                        </Button>
                        <Button
                            className="text-white ml-auto"
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleShowReminderAlert("notificationModal")}
                        >
                            {commonStrings.close}
                        </Button>
                    </div>
                </Modal>
                }
                {this.state.bookingCancelAlertFor !== null &&
                <Modal
                    className="modal-dialog-centered modal-danger"
                    contentClassName="bg-gradient-danger"
                    isOpen={this.state.showBookingCancelAlert}
                    toggle={() => this.toggleBookingCancelAlert("notificationModal")}
                >
                    <div className="modal-header">
                        <h6 className="modal-title" id="modal-title-notification">
                            {/*Your attention is required*/}
                        </h6>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleBookingCancelAlert("notificationModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="py-3 text-center">
                            <MdDelete size="50px"/>
                            <h4 className="heading mt-4">{alertStrings.confirmation_alert_title}</h4>
                            <p>
                                {alertStrings.formatString(alertStrings.remove_from_class, this.state.bookingCancelAlertFor.name)}
                            </p>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Col className="text-center">
                            <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                    onClick={this.removeFromClass}>
                                {alertStrings.remove_with_ticket}
                            </Button>

                            <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                    onClick={this.markAsCancellation}>
                                {alertStrings.remove_keep_ticket}
                            </Button>

                            {/*<Button*/}
                            {/*    className="text-white ml-auto"*/}
                            {/*    color="link"*/}
                            {/*    data-dismiss="modal"*/}
                            {/*    type="button"*/}
                            {/*    style={{marginTop: 10}}*/}
                            {/*    onClick={() => this.toggleBookingCancelAlert("notificationModal")}*/}
                            {/*>*/}
                            {/*    {commonStrings.cancel}*/}
                            {/*</Button>*/}

                        </Col>
                    </div>
                </Modal>
                }
                {this.state.unregisterAlertFor !== null &&
                <Modal
                    className="modal-dialog-centered modal-danger"
                    contentClassName="bg-gradient-danger"
                    isOpen={this.state.showUnregisterAlert}
                    toggle={() => this.toggleUnregisterAlert("notificationModal")}
                >
                    <div className="modal-header">
                        <h6 className="modal-title" id="modal-title-notification">
                            {/*Your attention is required*/}
                        </h6>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleUnregisterAlert("notificationModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="py-3 text-center">
                            <MdDelete size="50px"/>
                            <h4 className="heading mt-4">{alertStrings.confirmation_alert_title}</h4>
                            <p>
                                {alertStrings.formatString(alertStrings.remove_from_class, this.state.unregisterAlertFor.name)}
                            </p>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button
                            className="text-white ml-auto"
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleUnregisterAlert("notificationModal")}
                        >
                            {alertStrings.no}
                        </Button>
                        <Button className="btn-white" color="default" type="button"
                                onClick={this.unregisterFromClass}>
                            {alertStrings.yes}
                        </Button>
                    </div>
                </Modal>
                }
                <ClassHeader yclass={this.state.yclass} backToClass={this.state.backToClass}
                             navigateBack={this.goToPreviousClass}
                             showMessage={this.showMessage}
                             showExportData={this.showExportData}
                             alertData={this.state.alertData}
                             editClassAction={this.editClassAction}
                             toggleScan={this.toggleScan}
                             showClassPlan={this.showClassPlan}
                             toggleFeedback={this.toggleFeedback}
                             recheckTickets={this.recheckTickets}
                             goToClassReport={this.goToClassReport}
                             goToUnpaidReport={this.goToUnpaidReport}
                             backToClassReport={this.state.backToClassReport}
                             backToUnpaidReport={this.state.backToUnpaidReport}
                />
                <Container fluid style={{marginTop: -60}}>
                    <div ref={(ref) => this.secondarySectionRef = ref}/>
                    <Row>
                        <Col lg="4" xl="4" md="4" sm="4">
                            <FormGroup className="mb-0">
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="fas fa-search"/>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        value={this.state.searchValue}
                                        onChange={this.handleSearchChange}
                                        placeholder={commonStrings.add_to_class} type="text"/>

                                    {this.state.inputStarted &&
                                    <InputGroupAddon addonType="append" onClick={e => this.clearSearch(e)}>
                                        <InputGroupText>
                                            <i className="fas fa-times-circle"/>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    }
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        {this.state.inputStarted &&
                        <Col style={{marginStart: 20}}>
                            <Button
                                color="warning"
                                onClick={e => this.createClient(e)}
                            >
                                {commonStrings.create_new}
                            </Button>
                        </Col>
                        }
                        {/*{this.state.inputStarted === false &&*/}
                        {/*<Button*/}
                        {/*    color="secondary"*/}
                        {/*    onClick={e => this.scanCode(e)}*/}
                        {/*>*/}
                        {/*    <i style={{color: "dark-blue", marginRight: 8}} className="fas fa-qrcode"/>*/}
                        {/*    {commonStrings.scan_qr}*/}
                        {/*</Button>*/}
                        {/*}*/}
                    </Row>

                    <Row className="mt-5">
                        {this.state.showClassEditor === true &&
                        <Col xl="6">

                            <EditClassView
                                yclass={this.state.yclass}
                                closeEditClassView={this.closeEditClassView}
                                deleteClass={this.showClassDeletionModal}
                                teachers={this.state.teachers}
                                rooms={this.state.rooms}
                                showEditClassType={true}
                                showClassTypeEditor={this.showClassTypeEditor}
                            />

                        </Col>
                        }

                        {this.state.showCurrentClassPlan == true &&
                        <Col xl="6">
                            {this.renderClassPlan()}
                        </Col>
                        }

                        {this.state.showClassTypeEditor === true && this.state.classType &&
                        <Col xl="6">

                            <EditClassTypeView
                                closeEditClassTypeView={this.closeEditClassTypeView} classType={this.state.classType}
                                handleError={() => this.handleNetworkError}
                            />

                        </Col>
                        }

                        {this.state.showTicketEditor === true &&
                        <Col xl="6">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">{this.state.selectedTicketType && this.state.selectedTicketType.name ? this.state.selectedTicketType.name : this.state.ticketTemplate.name || ""}</h3>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <EditTicketView
                                        ticket={this.state.ticketTemplate}
                                        ticketType={this.state.selectedTicketType}
                                        currency={businessHelper.currency()}
                                        updateTicket={this.updateTicket}
                                        closeTicketView={this.closeTicketView}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                        }

                        {this.state.showClientPreview && this.state.showClientPreviewFor !== null &&
                        <Col xl="4" style={{marginTop: 10}}>
                            <StudentPreview clientId={this.state.showClientPreviewFor.id}
                                            closeClientPreview={this.closeClientPreview}
                                            showReminder={this.showReminderAlertView}
                                            goToClientProfile={this.goToClientProfile}/>
                        </Col>
                        }

                        {this.state.showTicketTypeSelector && this.state.ticketTypes !== null &&
                        <Col xl="4">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">{resourceStrings.select_tt}</h3>
                                        </Col>
                                        <div className="col text-right">
                                            <Button
                                                color="warning"
                                                onClick={e => this.closeTicketTypeSelector(e)}
                                                size="sm"
                                            >
                                                {commonStrings.cancel}
                                            </Button>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    {this.state.ticketTypes.filter(tt => {
                                        return !tt.membership
                                    }).map((tt) => (
                                        <ResourceItem
                                            key={tt.id}
                                            item_name={tt.name}
                                            membership={tt.membership}
                                            is_enrolment={tt.is_enrolment}
                                            smallText={true}
                                            icon={require("assets/img/icons/common/ticket_white.svg").default}
                                            item_extra={this.state.business.cur.split('-')[1] + " " + tt.price}
                                            onSelected={this.onTicketTypeSelected}
                                            invalidForClass={this.ticketTypeInvalidForThisClass(tt)}
                                        />
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>

                        }
                        {this.state.inputStarted &&
                        <Col xl="4">
                            <CardHeader className="border-0 mt-2">
                                <Row className="align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">{commonStrings.search_results}</h5>
                                    </div>
                                    <div className="col text-right">
                                        {this.state.searchLoading ?
                                            (<FadingBalls color="#272853" duration="3s" />)
                                            :

                                            (<Button
                                                color="warning"
                                                onClick={e => this.closeSearch(e)}
                                                size="sm"
                                            >
                                                {commonStrings.close}
                                            </Button>)}
                                    </div>
                                </Row>
                            </CardHeader>

                            <Table
                                className="align-items-center table-light table-flush mt-2"
                                responsive
                            >
                                <thead className="thead-dark">
                                <tr>
                                    <th scope="col">{studentStrings.select_client}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderSearchResults()}
                                </tbody>
                            </Table>
                        </Col>
                        }

                        {this.showScannerBanner() &&
                        <Col className="mb-xl-0">
                            <ScannerAlert style={{width: "100%"}} alertData={this.state.scannerState.text}
                                          toggleScanner={this.toggleScan} onScanResult={this.onScanResult.bind(this)}/>
                        </Col>
                        }

                        {this.state.classIsLoading &&
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%", position: "absolute"}}>
                                <FadingBalls color="#272853" duration="3s" />
                            </div>
                        }

                        <Col className="mb-5 mb-xl-0"
                             xl={this.clientTableWidth()}>
                            {this.renderTableData()}
                        </Col>
                    </Row>

                </Container>
            </>
        );
    }

    onScanResult(value) {
        if (this.qRcodeIsValid(value)) {
            const code = this.extractedCode(value);
            this.addToClass(null, code, true)
        } else {
            this.setState({scannerState: {state: "error", text: ""}})
        }
    }

    qRcodeIsValid(value) {
        return value && value.length > 3 && value.length < 45 && this.extractedCode(value)
    }

    extractedCode(value) {
        let code = value;
        if (code.includes("-")) code = code.split("-")[1]
        const numbersOnly = code.match(/\d/g).join("");
        if (numbersOnly && numbersOnly.length > 0 && numbersOnly.length < 7) return numbersOnly
        else return null
    }

    getClass(no_student_data = true) {
        this.setState({classIsLoading: true});

        if (this.state.yclassId === -1) {
            return <Redirect from="*" to="/admin/index"/>
        }

        ClassApiService.yclass(this.state.yclassId, no_student_data)
            .then(res => {
                this.setState({
                    yclass: res,
                    classIsLoading: false
                });
                this.getClassType(false)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    search(searchValue) {
        this.setState({searchLoading: true});
        StudentApiService.search(searchValue)
            .then(res => {
                this.setState({
                    searchResults: res.students,
                    searchLoading: false,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleSearchChange(event) {
        clearTimeout(filterTimeout);

        let searchValue = event.target.value;

        this.setState({
            searchValue: searchValue
        });

        if (searchValue.length > 1) {
            this.setState({
                inputStarted: true,
                showClientPreview: false,
                showClassEditor: false,
                showClassTypeEditor: false,
                alertData: null,
                showTicketTypeSelector: false,
                showTicketEditor: false,
            });

            filterTimeout = setTimeout(() => {
                this.search(searchValue)
            }, 500)

        } else if (searchValue.length === 0) {
            this.setState({
                searchValue: "",
                inputStarted: false,
                searchLoading: false,
            });

        }
    }

    clearSearch(e) {
        e.preventDefault();

        this.setState({
            searchValue: "",
            inputStarted: false
        });
    }

    createClient(ev) {
        ev.preventDefault();
        this.setState({isLoading: true});
        const name = this.state.searchValue;

        StudentApiService.createInClass({new_name: name, class_id: this.state.yclass.id})
            .then(res => {
                this.setState({
                    isLoading: false,
                    searchValue: "",
                    inputStarted: false,
                    lastAddedClientId: res.students.find(it => it.name === name).id || null
                });
                this.getClass()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    scanCode(ev) {
        ev.preventDefault()
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
    }

    closeSearch(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({
            searchLoading: false,
            searchResuls: [],
            searchValue: "",
            inputStarted: false
        })
    }

    removeDuplicates(cancelled_students) {
        if (cancelled_students.length > 0 && this.state.yclass && this.state.yclass.waitings && this.state.yclass.waitings.length > 0) {
            const n = cancelled_students.filter(n => !this.state.yclass.waitings.some(n2 => n.id === n2.id));
            return n
        } else return cancelled_students
    }

    updateFirstPosition(students) {
        if (this.state.yclass && this.state.lastAddedClientId !== null) {
            const id = this.state.lastAddedClientId;
            const studs = this.state.yclass.students;

            this.state.yclass.students.forEach(function (item, i) {
                if (item.id === id) {
                    studs.splice(i, 1);
                    studs.unshift(item);
                }
            });

            return studs
        } else {
            return this.state.yclass.students || []
        }
    }

    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    showNoTicketWarningIfNeeded(id) {
        if (lsHelpers.isUsingReminders()) {
            if (this.state.yclass.is_free === true) {

            } else {
                if (this.state.yclass.tickets) {
                    const ticket = this.state.yclass.tickets.find(t => t.student_id === id);

                    if (ticket) {
                    } else {
                        const client = this.state.yclass.students.find(it => it.id === id);

                        if (client) {
                            this.setState({
                                showReminderAlert: true,
                                reminderAlertFor: client
                            });
                        }
                    }
                }
            }
        }
    }

    confirmDeletion = (event, client) => {
        event.preventDefault();

        if (this.isBooking(client.id)) {
            this.setState({
                showBookingCancelAlert: true,
                bookingCancelAlertFor: client
            });
        } else {
            this.setState({
                showUnregisterAlert: true,
                unregisterAlertFor: client
            });
        }
    };

    removeFromClass() {
        this.setState({isLoading: true});

        ClassApiService.unregisterClient(this.state.yclass.id, this.state.bookingCancelAlertFor.id)
            .then(res => {
                this.setState({
                    yclass: res,
                    isLoading: false,
                    bookingCancelAlertFor: null
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    unregisterFromClass() {
        this.setState({isLoading: true});

        ClassApiService.unregisterClient(this.state.yclass.id, this.state.unregisterAlertFor.id)
            .then(res => {
                this.setState({
                    yclass: res,
                    isLoading: false,
                    unregisterAlertFor: null
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    markAsCancellation() {
        this.setState({isLoading: true});

        ClassApiService.markAsCancelled(this.state.yclass.id, this.state.bookingCancelAlertFor.id)
            .then(res => {
                this.setState({
                    yclass: res,
                    isLoading: false,
                    bookingCancelAlertFor: null
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getTicketTypes() {
        this.setState({isLoading: true});
        TicketTypeApiService.index()
            .then(res => {
                this.setState({
                    ticketTypes: res,
                    isLoading: false
                });

                this.ticketTypesSelector()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    findCancellation_data(student, yclass) {
        return (yclass.cancellation_info || []).find(ci => ci.student_id === student.id)
    }

    showTicketTypes(e, clientId) {
        if (e !== null) {
            e.preventDefault();
        }
        if (this.state.ticketTypes === null) {
            this.getTicketTypes();
        } else {
            this.ticketTypesSelector()
        }

        this.setState({ticketForStudentWithId: clientId})
    }

    ticketTypesSelector() {
        this.setState({
            showTicketTypeSelector: true,
            showClasses: false,
            showTickets: false,
            showClientPreview: false,
            showClassEditor: false,
            showClassTypeEditor: false,
            inputStarted: false,
            searchValue: ""
        });
    }

    closeTicketTypeSelector(e) {
        e.preventDefault();

        this.setState({
            showTicketTypeSelector: false,
        });
    }

    closeTicketView(ev) {
        ev.preventDefault();

        this.setState({
            showTicketEditor: false,
            showTickets: true,
            inputStarted: false,
            searchValue: ""
        })
    }

    onTicketTypeSelected = (e, ticketTypeName) => {
        e.preventDefault();
        const tt = this.state.ticketTypes.filter(tt => {
            return tt.name === ticketTypeName
        })[0];

        this.setState({
            ticketTemplate: ticketHelpers.createTicketTemplate(tt, this.state.studentId),
            showTickets: false,
            showTicketTypeSelector: false,
            selectedTicketType: tt,
            showTicketEditor: true,
        });
    };

    updateTicket(ticket) {
        this.setState({isLoading: true});

        TicketApiService.createInClass(this.state.ticketForStudentWithId, this.state.yclass.id, ticket)
            .then(res => {
                this.setState({
                    isLoading: false,
                    showTicketEditor: false,
                });

                this.getClass();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    ticketTypeInvalidForThisClass(ticketType) {
        const ticketIsValidForClass = resourceHelper.ticketTypeIsValidForClassType(this.state.classType, ticketType.id)
        const classTypeIsValidForTicket = resourceHelper.classTypeIsValidForTicket(ticketType, this.state.yclass.class_type_id)

        return !ticketIsValidForClass || !classTypeIsValidForTicket
    }

    createPaymentReminder() {
        const data = {
            "student_id": this.state.reminderAlertFor.id,
            "title": "uc",
            "created_by": this.state.business.id,
            "yclass_id": this.state.yclass.id
        };

        StudentApiService.createReminder(data)
            .then(res => {
                this.setState({
                    searchResults: res.students,
                    searchLoading: false,
                    reminderAlertFor: null,
                    showReminderAlert: false
                });
                this.getClass()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    toggleShowReminderAlert = state => {
        this.setState({
            showReminderAlert: !this.state.showReminderAlert
        });
    };

    toggleBookingCancelAlert = state => {
        this.setState({
            showBookingCancelAlert: !this.state.showBookingCancelAlert
        });
    };

    toggleUnregisterAlert = state => {
        this.setState({
            showUnregisterAlert: !this.state.showUnregisterAlert
        });
    };

    toggleReminderControls = state => {
        this.setState({
            showReminderControls: !this.state.showReminderControls
        });
    };

    closeClientPreview(ev) {
        ev.preventDefault();

        this.setState({
            showClientPreview: false,
            showClientPreviewFor: null
        })
    }

    clientPreview(client) {

        this.setState({
            showClientPreview: true,
            showClientPreviewFor: client,
            showClassEditor: false,
            showClassTypeEditor: false,
            inputStarted: false,
            searchValue: "",
            showTicketTypeSelector: false,
            showTicketEditor: false

        })
    }

    renderReminderControls() {
        return (
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={this.state.showReminderControls}
                toggle={() => this.toggleReminderControls("notificationModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleReminderControls("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <i className="ni ni-bell-55 ni-3x"/>
                        {/*<h4 className="heading mt-4">{alertStrings.confirmation_alert_title}</h4>*/}
                        <p>
                            {/*{alertStrings.formatString(alertStrings.remove_from_class, this.state.bookingCancelAlertFor.name)}*/}
                        </p>
                    </div>
                </div>
                <div className="modal-footer">
                    <Col className="text-center">
                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.deleteReminder}>
                            {alertStrings.delete_reminder}
                        </Button>

                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.goToClassFromReminder}>
                            {alertStrings.go_to_class}
                        </Button>

                    </Col>
                </div>
            </Modal>
        )
    }

    deleteReminder() {
        StudentApiService.deleteReminder(this.state.reminderToShow.id)
            .then(res => {
                this.setState({
                    reminderToShow: null,
                    showClientPreview: false,
                    isLoading: false,
                });

                this.getClass()

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    goToClassFromReminder() {
        // Here we also setting the id of current class to get back to unless it is already set
        this.setState({
            backToClass: this.state.backToClass ? this.state.backToClass : this.state.yclass,
            yclassId: this.state.reminderToShow.yclass_id,
            showClientPreview: false,
            showClassEditor: false,
            showClassTypeEditor: false,
            scrollToTop: true,
            showReminderControls: false
        })
    }

    showReminderAlertView(reminder) {
        this.setState({showReminderControls: true, reminderToShow: reminder})
    }

    goToPreviousClass() {
        if (this.state.backToClass !== null && this.state.backToClass !== this.state.yclass) {
            this.setState({
                yclassId: this.state.backToClass.id,
                showClientPreview: false,
                scrollToTop: true
            })
        }
    }

    goToClientProfile(ev, id) {
        ev.preventDefault();

        this.setState({moveToClientProfile: true, goToClientProfileId: id})
    }

    toggleMessageModal = state => {
        this.setState({
            showMessageModal: !this.state.showMessageModal
        });
    };

    renderSendMessageModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showMessageModal}
                toggle={() => this.toggleMessageModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{commonStrings.send_message}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <div className="text-center text-muted mt--2 mb-4">
                                <small>{resourceStrings.message_will_be_sent}</small>
                            </div>
                            <Form role="form">
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={resourceStrings.title} type="text"
                                               id="message-input-title"
                                               defaultValue={this.state.message.title}
                                               onChange={this.handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={commonStrings.message}
                                               type="textarea" rows="5"
                                               id="message-input-text"
                                               defaultValue={this.state.message.message}
                                               onChange={this.handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <div className="text-center">
                                    {this.state.message && this.state.message.message && this.state.message.message.length > 10 &&
                                    <Button
                                        className="my-4"
                                        color="primary"
                                        type="button"
                                        onClick={e => this.sendMessageAction(e)}
                                    >
                                        {commonStrings.send}
                                    </Button>
                                    }
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    showMessage(e) {

        e.preventDefault();

        if (subscriptionHelpers.hasSubscription()) this.setState({showMessageModal: true})
        else this.setState({showNotProModal: true})
    }

    toggleNotProModal() {
        this.setState({showNotProModal: false})
    }

    sendMessageAction(e) {
        e.preventDefault();

        this.setState({
            isLoading: true,
        });

        ClassApiService.sendMessage(this.state.yclass.id, this.state.message)
            .then(res => {
                this.setState({
                    isLoading: false,
                    showMessageModal: false,
                    alertData: {
                        type: 'success',
                        text: `${alertStrings.message_sent_success}`
                    }
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleMessageInputChange(event) {
        this.setState({
            profileWasUpdated: true,
        });

        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "message-input-title":
                this.setState(prevState => ({
                    message: {
                        ...prevState.message,
                        title: newValue
                    }
                }));
                break;
            case "message-input-text":
                this.setState(prevState => ({
                    message: {
                        ...prevState.message,
                        message: newValue
                    }
                }));
                break;
            default:
                return
        }
    }

    exportDataAction(e) {
        e.preventDefault();

        ClassApiService.exportData(this.state.yclass.id)
            .then(res => {
                this.setState({
                    isLoading: false,
                    showExportModal: false,
                    alertData: {
                        type: 'success',
                        text: `${alertStrings.class_export_data_success}`
                    }
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showExportData(e) {
        e.preventDefault();

        if (subscriptionHelpers.hasSubscription()) this.setState({showExportModal: true})
        else this.setState({showNotProModal: true})
    }

    toggleExportModal = state => {
        this.setState({
            showExportModal: !this.state.showExportModal
        });
    };

    renderExportDataModal() {
        return (<Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={this.state.showExportModal}
            toggle={() => this.toggleExportModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleExportModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-file-download"/>
                    <h4 className="heading mt-4">{alertStrings.confirmation_alert_title}</h4>
                    <p>
                        {alertStrings.class_export_data_expl}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleExportModal("notificationModal")}
                >
                    {alertStrings.no}
                </Button>
                <Button className="btn-white" color="default" type="button"
                        onClick={this.exportDataAction}>
                    {alertStrings.yes}
                </Button>
            </div>
        </Modal>)
    }

    closeEditClassView(e) {
        if (e) {
            e.preventDefault()
        }

        this.setState({showClassEditor: false, scrollToTop: true});
        this.getClass()
    }

    showClassDeletionModal(e) {
        if (e) {
            e.preventDefault()
        }
        this.setState({showClassDeletionModal: true})
    }

    deleteClass() {
        this.setState({isLoading: true});
        ClassApiService.deleteYclass(this.state.yclassId)
            .then(res => {
                this.setState({backToSchedule: true, isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    closeEditClassTypeView(e, ct) {
        if (e) {
            e.preventDefault()
        }

        this.setState({showClassTypeEditor: false, scrollToTop: true});
        if (ct) {
            this.setState({classType: ct});
        }
        this.getClass()
    }

    clientTableWidth() {
        if (this.state.showClassEditor || this.state.showClassTypeEditor || this.state.showCurrentClassPlan) {
            return '6'
        } else if (this.state.inputStarted || this.state.showTicketTypeSelector || this.state.showClientPreview) {
            return '8'
        } else if (this.state.showTicketEditor) {
            return '6'
        } else return '12'

    }

    showClassTypeEditor(e) {
        if (e) {
            e.preventDefault();
        }

        if (this.state.classType !== null) {
            this.setState({
                showClassEditor: false,
                showClassTypeEditor: true,
                inputStarted: false,
                showClientPreview: false,
                alertData: null,
                showTicketTypeSelector: false,
                showTicketEditor: false,
                scrollToTop: true,
            })
        } else this.getClassType()
    }

    getClassType(showEditor = true) {
        this.setState({isLoading: true});

        if (this.state.yclass && this.state.yclass.class_type_id) {
            ResourceApiService.classType(this.state.yclass.class_type_id)
                .then(res => {
                    this.setState({
                        classType: res,
                        isLoading: false,
                    });

                    if (showEditor) {
                        this.showClassTypeEditor()
                    }
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    toggleScan(e) {
        if (e) e.preventDefault();

        const newState = this.state.scannerState.state === "pending" ? "scanning" : "pending"
        this.setState({scannerState: {state: newState, text: ""}})
    }

    editClassAction(e) {
        e.preventDefault();

        if (this.state.teachers !== null && this.state.rooms !== null) {
            this.setState({
                showClassEditor: true,
                showClassTypeEditor: false,
                inputStarted: false,
                showClientPreview: false,
                alertData: null,
                showTicketTypeSelector: false,
                showTicketEditor: false,
            })
        } else this.getTeachersAndRooms()
    }

    getTeachersAndRooms() {
        this.setState({isLoading: true});

        ResourceApiService.teachersAndRooms()
            .then(res => {
                this.setState({
                    isLoading: false,
                    teachers: res[0] || [],
                    rooms: res[1] || [],
                    showClassEditor: true,
                    showClassTypeEditor: false,
                    inputStarted: false,
                    showClientPreview: false,
                    alertData: null,
                    showTicketTypeSelector: false,
                    showTicketEditor: false,
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    toggleDeletionModal = state => {
        this.setState({
            showClassDeletionModal: !this.state.showClassDeletionModal
        });
    };

    renderDeletionModal() {
        return (
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={this.state.showClassDeletionModal}
                toggle={() => this.toggleDeletionModal("notificationModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleDeletionModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <MdDelete size="50px"/>
                        {alertStrings.confirmation_alert_title}
                        <p>
                            {alertStrings.confirm_delete_class}
                        </p>
                    </div>
                </div>
                <div className="modal-footer">
                    <Col className="text-center">
                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.deleteClass}>
                            {alertStrings.yes}
                        </Button>

                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={this.toggleDeletionModal}>
                            {alertStrings.no}
                        </Button>

                    </Col>
                </div>
            </Modal>
        )
    }

    confirmBooking(e, student) {
        if (e) e.preventDefault();

        this.setState({
            isLoading: true,
        });

        ClassApiService.confirmBooking(student.id, this.state.yclassId)
            .then(res => {
                this.getClass()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    unconfirmBooking(e, student) {
        if (e) e.preventDefault();

        this.setState({
            isLoading: true,
        });

        ClassApiService.unconfirmBooking(student.id, this.state.yclassId)
            .then(res => {
                this.getClass()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showScannerBanner() {
        return this.state.scannerState.state === "scanning"
    }

    isConfirmedBooking(student) {
        const confirmations = this.state.yclass.confirmed_bookings
        if (confirmations && confirmations.length > 2) {
            const c = confirmations.replace("{", "").replace("}", "").split(",").map(id => parseInt(id));
            return c.includes(student.id)
        } else return false
    }

    showClassPlan() {
        if (this.state.classPlan == null) {
            this.getClassPlan(true)
        } else {
            this.setState({
                showClassEditor: false,
                showTicketTypeSelector: false,
                showClientPreview: false,
                showCurrentClassPlan: true
            });
        }
    }

    toggleFeedback() {
        let feedbacks = this.state.yclass.feedbacks || [];
        let students = (this.state.yclass.students || []).concat(this.state.yclass.bookings || [])
        feedbacks.forEach(f => {
            if (f.student_id) {
                const client = students.find(s => s.id == f.student_id)
                if (client) {
                    f.client_name = client.name
                    f.client_photo = client.photo
                }
            }
        })

        this.setState(prevState => ({
            yclass: {
                ...prevState.yclass,
                feedbacks: feedbacks
            },
            showFeedback: !this.state.showFeedback
        }));
    }
    ;

    renderFeedbackModal() {
        return (
            <FeedbackComponent
                feedbacks={this.state.yclass.feedbacks}
                showFeedback={this.state.showFeedback}
                toggleFeedback={this.toggleFeedback}
            />
        )
    }

    getClassPlan(getClassPlans = false) {
        this.setState({isLoading: true});

        ClassApiService.yclassPlan(this.state.yclassId)
            .then(res => {
                if (res == null) {
                    res = resourceHelper.emptyClassPlan()
                }
                this.setState({
                    classPlan: res,
                    isLoading: false,
                    showCurrentClassPlan: true
                });

                if (getClassPlans) this.getCLassPlans()
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    getCLassPlans() {
        const updateCPView = this.state.classPlanViewUpdated + 1;
        ClassApiService.getCLassPlans()
            .then(res => {
                this.setState({
                    classPlans: res,
                    classPlanViewUpdated: updateCPView,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    closeClassPlanView() {
        this.setState({
            showCurrentClassPlan: false
        });
    }

    renderClassPlan() {
        if (this.state.classPlan == null) {
            this.getClassPlan(true)
        } else {
            return (<ClassPlanView classPlan={this.state.classPlan}
                                   closeView={this.closeClassPlanView.bind(this)}
                                   updateClassPlanTitle={this.updateClassPlanTitle.bind(this)}
                                   updateClassPlanPublic={this.updateClassPlanPublic.bind(this)}
                                   classPlanViewUpdated={this.state.classPlanViewUpdated}
                                   addCPI={this.addCPI.bind(this)}
                                   removeCPI={this.removeCPI.bind(this)}
                                   deleteCP={this.deleteClassPlan.bind(this)}
                                   classPlans={this.state.classPlans}
                                   className={this.state.yclass.name}
                                   classDate={dateHelpers.formatDate(new Date(this.state.yclass.date))}
                                   reuseFor={this.reuseClassPlanFor.bind(this)}
                                   reuseClassPlan={this.reuseClassPlan.bind(this)}
            />)
        }
    }

    updateClassPlanTitle(classPlan) {
        this.setState({isLoading: true});
        const updateCPView = this.state.classPlanViewUpdated + 1;

        if (classPlan.id) {
            ClassApiService.updateClassPlanTitle(this.state.yclassId, classPlan)
                .then(res => {
                    let y = this.state.yclass;
                    y.class_plan = res

                    this.setState({
                        yclass: y,
                        classPlanViewUpdated: updateCPView,
                        classPlan: res,
                        isLoading: false,
                        showCurrentClassPlan: true
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        } else {
            ClassApiService.createClassPlan(this.state.yclassId, classPlan)
                .then(res => {
                    let y = this.state.yclass;
                    y.class_plan = res

                    this.setState({
                        yclass: y,
                        classPlanViewUpdated: updateCPView,
                        classPlan: res,
                        isLoading: false,
                        showCurrentClassPlan: true
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    updateClassPlanPublic(classPlan, isPublic) {
        const updateCPView = this.state.classPlanViewUpdated + 1;
        ClassApiService.updateClassPlanPublic(this.state.yclassId, classPlan, isPublic)
            .then(res => {
                this.setState({
                    classPlanViewUpdated: updateCPView,
                    classPlan: res,
                    isLoading: false,
                    showCurrentClassPlan: true
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    reuseClassPlan(classPlan) {

        this.setState({
            isLoading: true,
        });

        const updateCPView = this.state.classPlanViewUpdated + 1;
        ClassApiService.reuseClassPlan(this.state.yclassId, classPlan)
            .then(res => {
                this.setState({
                    classPlanViewUpdated: updateCPView,
                    classPlan: res,
                    isLoading: false,
                    showCurrentClassPlan: true
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    reuseClassPlanFor(e, typeOfReuse) {
        e.preventDefault();

        this.setState({
            isLoading: true,
        });

        const updateCPView = this.state.classPlanViewUpdated + 1;
        ClassApiService.reuseClassPlanFor(this.state.yclassId, typeOfReuse)
            .then(res => {
                this.setState({
                    classPlanViewUpdated: updateCPView,
                    isLoading: false,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    addCPI(classPlan, itemTitle) {
        const updateCPView = this.state.classPlanViewUpdated + 1;
        ClassApiService.addCPItem(this.state.yclassId, classPlan, itemTitle)
            .then(res => {
                let y = this.state.yclass;
                y.class_plan = res

                this.setState({
                    yclass: y,
                    classPlanViewUpdated: updateCPView,
                    classPlan: res,
                    isLoading: false,
                    showCurrentClassPlan: true
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    removeCPI(classPlan, itemId) {
        const updateCPView = this.state.classPlanViewUpdated + 1;
        ClassApiService.removeCPItem(this.state.yclassId, classPlan, itemId)
            .then(res => {
                let y = this.state.yclass;
                y.class_plan = res

                this.setState({
                    yclass: y,
                    classPlanViewUpdated: updateCPView,
                    classPlan: res,
                    isLoading: false,
                    showCurrentClassPlan: true
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    deleteClassPlan(classPlan) {
        const updateCPView = this.state.classPlanViewUpdated + 1;
        ClassApiService.deleteClassPlan(this.state.yclassId, classPlan)
            .then(res => {
                let y = this.state.yclass;
                y.class_plan = res

                this.setState({
                    yclass: y,
                    classPlanViewUpdated: updateCPView,
                    classPlan: res,
                    isLoading: false,
                    showCurrentClassPlan: false
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }
}

export default withRouter(ClassOverview);
